module.exports = __webpack_public_path__ + "static/img/9.2d295ca.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/2/1/1/zh/9.png
// module id = sm6y
// module chunks = 0